/** Limite de pontos renderizados no SVG do Recharts (hover mapeia para o índice original). */
export const SPEED_CHART_MAX_DISPLAY_POINTS = 1200

export interface DownsampledChartData<T> {
  displayData: readonly T[]
  toSourceIndex: (chartIndex: number) => number
}

/**
 * Reduz pontos para desenho do gráfico mantendo primeiro e último valor.
 * O índice do hover no gráfico é convertido de volta ao array completo via `toSourceIndex`.
 */
export function downsampleChartData<T>(
  data: readonly T[],
  maxPoints = SPEED_CHART_MAX_DISPLAY_POINTS,
): DownsampledChartData<T> {
  const len = data.length
  if (len <= maxPoints) {
    return {
      displayData: data,
      toSourceIndex: (chartIndex) => Math.min(Math.max(chartIndex, 0), len - 1),
    }
  }

  const displayData: T[] = []
  const chartToSource: number[] = []
  const lastChart = maxPoints - 1

  for (let i = 0; i < maxPoints; i++) {
    const sourceIndex = Math.min(len - 1, Math.round((i / lastChart) * (len - 1)))
    displayData.push(data[sourceIndex]!)
    chartToSource.push(sourceIndex)
  }

  return {
    displayData,
    toSourceIndex: (chartIndex) => {
      const clamped = Math.min(Math.max(chartIndex, 0), chartToSource.length - 1)
      return chartToSource[clamped] ?? 0
    },
  }
}
